import { createContext, useContext, useState } from 'react';

const AccessStageContext = createContext({
  accessStage: 'NONE',
  setAccessStage: () => {},
});

export function AccessStageProvider({ children }) {
  const [accessStage, setAccessStage] = useState('NONE');

  return (
    <AccessStageContext.Provider value={{ accessStage, setAccessStage }}>
      {children}
    </AccessStageContext.Provider>
  );
}

export function useAccessStage() {
  const context = useContext(AccessStageContext);
  if (!context) {
    throw new Error('useAccessStage deve ser usado dentro de AccessStageProvider');
  }
  return context;
}
